/**
 * Determine the mobile operating system.
 * This function returns true if 'iOS', 'Android', or 'Windows Phone', otherwise return false.
 *
 * @returns {Boolean}
 */
function isMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if ((/windows phone/i.test(userAgent)) || (/android/i.test(userAgent)) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
        return true;
    }

    return false;
}

// Override default onChange, that triggers only jquery event. We need to dispatch event via vanilla JS to invoke nette validation.
$.extend(Selectize.prototype, {
    onChange() {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            const evt = document.createEvent('UIEvents');
            evt.initUIEvent('change', true, false, window, 0);
            this.$input[0].dispatchEvent(evt);
        } else {
            this.$input[0].dispatchEvent(new Event('change', {bubbles: true}));
        }
    },
});

/*
*   when inicialized, element classes are cloned to selectize container, so use element name for initizalization as well,
*   :not selector should block duplicate initialization, as initialized select has class selectized
*/
Bingo.Select = {};
Bingo.Select.init = function () {
    $('select.js-select:not(.selectized)').selectize({
        allowEmptyOption: true,
        copyClassesToDropdown: false,
        create: false,
        render: {
            item(item) {
                return `<span class="A-select__value">${item.text}</span>`;
            },
            option(item) {
                return `<div class="A-selectDropdown__option">${item.text}</div>`;
            },
        },
        onInitialize() {
            this.$control_input[0].type = 'text';
            this.$control_input.addClass('A-select__input no-live-validation');
            this.$control_input.attr('data-lfv-dont-remove-group-error-label', 'true');
            this.$dropdown.closest('.selectize-control').find('.items').addClass('A-textField__formElement').addClass('js-textField__formElement');
            this.$dropdown.addClass('A-selectDropdown');
            this.$dropdown_content.addClass('A-selectDropdown__options');

            this.$input.on('focus', function () {
                this.focus();
            });

            const optionsCount = Object.keys(this.options).length;

            // readonly -> behave as regular styled select, this is due to keyboard poping up and covering options list
            if (isMobileOperatingSystem() && optionsCount < 15) {
                this.$control_input.attr('readonly', 'true');
            }
        },
        onDropdownClose() {
            const value = this.getValue();
            if (!value.length && !this.$wrapper.hasClass('redraw')) {
                this.clear();
            }
        },
    });
};
